import React, { useEffect, useState } from 'react';




export const renderMermaid = async (id: string, content: string, element?: Element) => {
  const { default: Mermaid } = await import('mermaid');
  return Mermaid.render(id, content, element)

}

export interface MermaidDiagramProps {
  id?: string;
  content: string;
}

let idCnt = 1;

export default function MermaidDiagram(props: MermaidDiagramProps) {

  const [_svg, setSvg] = useState<any>();

  useEffect(() => {
    let id = props.id ?? `mermaid-${idCnt}`
    idCnt++;

    renderMermaid(id, props.content).then(result => {
      setSvg(result.svg);
    })
  }, [props.content])

  return (
    <div className="mermaid" dangerouslySetInnerHTML={{ __html: _svg }}></div>
  )
}

